module.exports = __webpack_public_path__ + "img/logo_news_all@4x.c4230486.png";